export function insert(arr, index, ...items) {
  arr.splice( index, 0, ...items );
}
